const matched = (arr: Array<any>, value: any) =>
  arr.some(item => {
    if (typeof item === 'function') {
      return item(value)
    }
    if (Number.isNaN(item)) {
      return Number.isNaN(value)
    }
    return item === value
  })

/*
 * FIXME
 *  `any` return type needs to be fixed
 *  https://github.com/madup-inc/lever-utils/pull/17#discussion_r842625094
 * */
export default function (arr: Array<any>, target?: any): any {
  return arguments.length === 2
    ? matched(arr, target)
    : (target: any) => matched(arr, target)
}
